import { type Maybe } from '@lingoda/monolith-graphql';

export const isLessonLocked = (lesson: Maybe<{ availableWithoutPayment: boolean }>) =>
    !lesson?.availableWithoutPayment;
